import { Theme, useTheme } from '@material-ui/core/styles';
import { Box, makeStyles } from '@material-ui/core';
import React from 'react';
import { GetRailProps } from 'react-compound-slider';

const trackHeight = 3;
const thumbHeight = 10;

const useStyles = makeStyles({
  rail: {
    width: '100%',
    height: `${trackHeight}px`,
    position: 'absolute',
    pointerEvents: 'none'
  },
  hotSpot: {
    width: '100%',
    height: `${thumbHeight * 2}px`,
    top: `${thumbHeight * -1}px`,
    position: 'absolute',
    cursor: 'pointer'
  }
});

interface SliderRailProps {
  disabled?: boolean;
  getRailProps: GetRailProps;
}

const SliderRail: React.VFC<SliderRailProps> = ({ disabled, getRailProps }) => {
  const classes = useStyles();
  const theme = useTheme<Theme>();

  return (
    <React.Fragment>
      <Box
        className={classes.hotSpot}
        style={{ cursor: disabled && 'initial' }}
        {...getRailProps()}
      />
      <Box
        className={classes.rail}
        style={{
          background: disabled
            ? theme.palette.background.paper
            : theme.palette.secondary.main
        }}
      />
    </React.Fragment>
  );
};

export default SliderRail;
